const staticText = {
  title: 'Verify your email',
  sendVerificationOpening: 'In order to upgrade your account',
};

export default staticText;
